module.exports = __webpack_public_path__ + "static/media/vaccination_place.1410d860.png";